import React, { FC } from 'react';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { Box } from '@mui/material';
import { ChipType } from '../../helpers/Constants';
import CustomChip from '../common/CustomChip';
import styles from './styles';

interface IWorkshiftListRightSection {
  hourlyRateLabel: string;
  isWatchlist: boolean;
}

const WorkshiftListRightSection: FC<IWorkshiftListRightSection> = ({
  hourlyRateLabel,
  isWatchlist,
}) =>
  (
    <Box sx={styles.rightContainer}>
      <Box>{isWatchlist && <BookmarkIcon sx={styles.iconColor} />}</Box>
      <CustomChip label={hourlyRateLabel} type={ChipType.hourlyRate} />
    </Box>
  );

export default WorkshiftListRightSection;
